'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHtmlId = require('react-html-id');

var _propTypes3 = require('../propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkForm = (_temp = _class = function (_React$Component) {
  _inherits(LinkForm, _React$Component);

  function LinkForm(props) {
    _classCallCheck(this, LinkForm);

    var _this = _possibleConstructorReturn(this, (LinkForm.__proto__ || Object.getPrototypeOf(LinkForm)).call(this, props));

    _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit();
    };

    _this.pageSelected = function (event) {
      var page = null;
      if (event.target.value) {
        page = _this.props.pages.find(function (existingPage) {
          return existingPage.id.toString() === event.target.value;
        });
      }

      var currentPage = _this.props.pages.find(function (existingPage) {
        return existingPage.id === _this.props.navigationItem.page_id;
      });

      var titleIsBlank = !_this.props.navigationItem.title;
      var titleExactlyMatchesPage = currentPage && _this.props.navigationItem.title === currentPage.name;

      if (titleIsBlank || titleExactlyMatchesPage) {
        _this.props.onTitleChanged(page ? page.name : '');
      }

      _this.props.onPageChanged(page);
    };

    _this.titleChanged = function (event) {
      _this.props.onTitleChanged(event.target.value);
    };

    _this.render = function () {
      var pageId = _this.nextUniqueId();
      var titleId = _this.nextUniqueId();

      var options = _this.props.pages.map(function (page) {
        return _react2.default.createElement(
          'option',
          { key: page.id, value: page.id },
          page.name
        );
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: _this.onSubmit },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { htmlFor: pageId },
            'Page to link to'
          ),
          _react2.default.createElement(
            'select',
            {
              id: pageId,
              className: 'form-control',
              onChange: _this.pageSelected,
              value: _this.props.navigationItem.page_id || ''
            },
            _react2.default.createElement('option', null),
            options
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { htmlFor: titleId },
            'Text of link on navigation bar'
          ),
          _react2.default.createElement('input', {
            id: titleId,
            type: 'text',
            className: 'form-control',
            onChange: _this.titleChanged,
            value: _this.props.navigationItem.title
          })
        )
      );
    };

    (0, _reactHtmlId.enableUniqueIds)(_this);
    return _this;
  }

  return LinkForm;
}(_react2.default.Component), _class.propTypes = {
  navigationItem: _propTypes3.NavigationItemPropType.isRequired,
  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    name: _propTypes2.default.string.isRequired
  }).isRequired).isRequired,
  onPageChanged: _propTypes2.default.func.isRequired,
  onTitleChanged: _propTypes2.default.func.isRequired,
  onSubmit: _propTypes2.default.func.isRequired
}, _temp);
exports.default = LinkForm;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/LinkForm.js
// module id = 408
// module chunks = 0